import { SET_BREADCRUMB_TITLE } from './actions/uiActions';

const initialState = {
  breadcrumbOverrides: {},
};

export const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BREADCRUMB_TITLE:
      return {
        ...state,
        breadcrumbOverrides: {
          ...state.breadcrumbOverrides,
          [action.payload.path]: action.payload.title,
        },
      };
    default:
      return state;
  }
};
